import script from "./ShowOnboarding.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowOnboarding.vue?vue&type=script&setup=true&lang=js"

import "./ShowOnboarding.vue?vue&type=style&index=0&id=52b98424&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b98424"]])

export default __exports__